<template>
    <div class="metrics_page">
        <PageTitle :title="'Metrics'"></PageTitle>
        <div class="container-1200 citation_content">
            At Contrimetric, we are redefining the landscape of scholarly evaluation with our innovative
            <span>
                Article Citation Contribution Indicator (ACCI)
            </span>, also known as the <span>Contribution Factor (CF)</span>. This pioneering metric
            offers a nuanced and equitable assessment of individual research articles, moving beyond traditional
            citation counts to illuminate the true impact of scholarly work.​
        </div>

        <div class="citation_box container-1200">
            <div class="citation_title">What is the ACCI?</div>
            <div class="citation_content">The ACCI is a sophisticated bibliometric tool designed to measure the
                contribution of a single article relative to the overall impact of its publishing journal. By focusing
                on individual article performance within its specific context, the ACCI provides a fairer and more
                precise evaluation of research significance, addressing the limitations of conventional metrics that
                often overlook the distinct value of singular works.​
            </div>
        </div>

        <div class="citation_box container-1200">
            <div class="citation_title">Why Choose ACCI?</div>

            <div class="citation_list">
                <ul>
                    <li class="citation_item">
                        <span class="storng_text">Precision</span>: Delivers an accurate reflection of an article's
                        influence within its journal's ecosystem.
                    </li>
                    <li class="citation_item">
                        <span class="storng_text">Equity</span>: Ensures that each piece of research is assessed on its
                        own merits, promoting a balanced and just evaluation process.​
                    </li>
                    <li class="citation_item">
                        <span class="storng_text">Insight</span>: Empowers researchers, institutions, and publishers
                        with deeper understanding of scholarly impact, facilitating informed decisions and strategies.​
                    </li>
                </ul>
            </div>
            <div class="citation_content pl20">By integrating the ACCI into your research assessment framework, you
                embrace a
                metric that truly captures the essence of academic contribution. Join us in advancing a more insightful
                and impactful scholarly community with Contrimetric's ACCI.
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from "@/components/pageTitle/index.vue"

export default {
    components: {
        PageTitle
    },
    data() {
        return {

        }
    }
}
</script>

<style lang='scss' scoped>
.m20 {
    margin-top: 80px;
}

.pl20 {
    padding-left: 30px;
}

.metrics_page {
    padding-top: 30px;
    padding-bottom: 300px;
    background-color: #f6fafc;
    background-image: url(../../assets/images/about_bj.png);
    background-size: 485px;
    background-repeat: no-repeat;
    background-position-x: 1080px;
}

.citation_box {
    margin-top: 30px;

    .storng_text {
        font-weight: bold;
    }

    .citation_title {
        font-size: 20px;
        font-weight: bold;
        color: black;
    }

    .citation_list {
        padding: 0 30px;
        background-color: transparent;
        border-radius: 10px;

        .citation_item {
            font-size: 16px;
            position: relative;
            list-style: disc;
            line-height: 1.5;

            &::marker {
                font-size: 24px;
            }
        }
    }
}

.citation_content {
    font-size: 16px;
    line-height: 1.5;
}

@media (max-width: 768px) {
    .first {
        flex-direction: column;
    }

    .citation_box {
        padding: 0 20px;
        margin-top: 30px;
        padding-bottom: 30px;

        .citation_title {
            font-size: 24px;
        }
    }
}
</style>